export const documentFormFields = (documentTypes, alwaysOnTop, setAlwaysOnTop) => [
  {
    type: "text",
    name: "title",
    label: "Title",
    validation: (value) => (!value ? "Title is required" : null),
  },
  {
    type: "select",
    name: "type",
    label: "Type",
    options: Object.entries(documentTypes).map(([key, value]) => ({ key, value })),
    validation: (value) => (!value ? "Type is required" : null),
  },
  {
    type: "switch",
    name: "alwaysOnTop",
    label: "Always on top",
    value: alwaysOnTop,
    onChange: setAlwaysOnTop,
  },
  {
    type: "textarea",
    name: "description",
    label: "Description",
  },
];